import { purple } from "@mui/material/colors";
import React from "react";
import { LetterIcon } from "./LetterIcon";

export const PartnerIcon = () => {
  return <LetterIcon color={purple[500]} title="Partner" />;
};
